var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupvendo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 70,
    viewBox: "0 0 68 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9997 70.0004C52.3889 70.0004 67.3871 55.0022 67.3871 36.613C67.3871 18.2238 52.3889 3.22572 33.9997 3.22572C15.6105 3.22572 0.612305 18.2239 0.612305 36.6131C0.612305 55.0023 15.6105 70.0004 33.9997 70.0004Z",
    fill: "url(#paint0_linear_35_7)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6257 15.0188H50.3775V29.4705H17.6257V15.0188Z",
    fill: "#444444"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3234 21.9559V10.7714C49.3234 8.60889 48.4747 7.16322 47.0059 5.70225C40.5532 -0.703983 24.3381 -2.0992 23.1754 3.50094C23.0049 4.3341 25.0202 6.39979 23.7373 6.46951C19.4433 6.69428 18.676 8.95369 18.676 12.4804V21.9559H49.3234Z",
    fill: "#444444"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9997 42.531L52.0983 52.2508C54.9971 53.8087 56.683 56.63 56.683 59.9164V61.1062C50.7302 66.6248 42.7583 70.0004 33.9997 70.0004C25.2411 70.0004 17.2731 66.6248 11.3164 61.1062V59.9164C11.3164 56.63 13.0023 53.8087 15.9011 52.2508L33.9997 42.531Z",
    fill: "#2096F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4718 46.0072V36.5549H27.5276V46.0072L33.9997 49.4719L40.4718 46.0072Z",
    fill: "#F6C9AA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0205 48.4295C27.9967 57.3043 25.559 56.5564 33.9997 49.4719L26.1984 45.2942C25.8767 45.1198 25.5357 45.0889 25.183 45.1935C24.8342 45.298 24.5706 45.5152 24.3963 45.8369L23.0205 48.4295Z",
    fill: "#1A7AC5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9789 48.4295C40.0066 57.3043 42.4404 56.5564 33.9996 49.4719L41.8009 45.2942C42.1264 45.1198 42.4636 45.0889 42.8163 45.1935C43.1689 45.298 43.4325 45.5152 43.603 45.8369L44.9789 48.4295Z",
    fill: "#1A7AC5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9765 57.0252C33.5075 57.0252 33.1277 56.6454 33.1277 56.1803C33.1277 55.7114 33.5075 55.3355 33.9765 55.3355H34.0269C34.492 55.3355 34.8718 55.7115 34.8718 56.1803C34.8718 56.6454 34.492 57.0252 34.0269 57.0252H33.9765ZM33.9765 60.6372C33.5075 60.6372 33.1277 60.2574 33.1277 59.7924C33.1277 59.3235 33.5075 58.9476 33.9765 58.9476H34.0269C34.492 58.9476 34.8718 59.3236 34.8718 59.7924C34.8718 60.2575 34.492 60.6372 34.0269 60.6372H33.9765Z",
    fill: "#1A7AC5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3853 25.6881H48.6143C50.6411 25.6881 52.2999 27.3467 52.2999 29.3737C52.2999 31.4006 50.6412 33.0554 48.6143 33.0554H19.3853C17.3584 33.0554 15.6996 31.4006 15.6996 29.3737C15.6996 27.3467 17.3583 25.6881 19.3853 25.6881ZM40.4718 45.019C38.4953 45.9181 36.3057 46.418 33.9997 46.418C31.6976 46.418 29.5041 45.9181 27.5276 45.019V36.5549H40.4717L40.4718 45.019Z",
    fill: "#F3AB7D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5447 22.39V30.6951C46.5447 37.5935 40.8981 43.2402 33.9997 43.2402C27.1013 43.2402 21.4548 37.5935 21.4548 30.6951L21.4626 21.9559C21.4161 20.115 21.4936 13.0579 25.6287 13.86C30.3801 14.7746 32.4534 16.2124 37.9644 14.9373C43.3785 13.6817 46.0914 13.7553 46.5253 21.9558L46.5447 22.39Z",
    fill: "#F6C9AA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6257 21.9559H50.3775V12.244C50.3775 10.5232 48.9669 9.11256 47.2461 9.11256H20.7533C19.0326 9.11256 17.6259 10.5232 17.6259 12.244V21.9559H17.6257Z",
    fill: "#2096F3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9013 21.9559H53.0982V19.3554C53.0982 17.9215 51.9278 16.751 50.4977 16.751H17.5055C16.0716 16.751 14.9012 17.9215 14.9012 19.3554L14.9013 21.9559ZM25.7604 68.9735V65.0204H17.8543V65.8381C20.3439 67.2189 23.0011 68.2727 25.7604 68.9735ZM50.145 65.8381V65.0204H42.2389V68.9734C44.9982 68.2728 47.6555 67.219 50.145 65.8381Z",
    fill: "#1A7AC5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4835 27.653C39.4835 27.1841 39.8595 26.8082 40.3284 26.8082C40.7935 26.8082 41.1733 27.1842 41.1733 27.653V29.0017C41.1733 29.4668 40.7935 29.8466 40.3284 29.8466C40.2174 29.8467 40.1075 29.8249 40.005 29.7825C39.9025 29.74 39.8093 29.6778 39.7308 29.5993C39.6523 29.5209 39.5901 29.4277 39.5477 29.3251C39.5052 29.2226 39.4834 29.1127 39.4835 29.0017V27.653ZM26.8262 27.653C26.8261 27.542 26.8479 27.4321 26.8904 27.3296C26.9328 27.2271 26.9951 27.1339 27.0735 27.0554C27.152 26.977 27.2452 26.9148 27.3477 26.8723C27.4503 26.8299 27.5602 26.8081 27.6711 26.8082C28.1401 26.8082 28.5159 27.1842 28.5159 27.653V29.0017C28.5159 29.4668 28.1399 29.8466 27.6711 29.8466C27.206 29.8466 26.8262 29.4668 26.8262 29.0017V27.653Z",
    fill: "#444444"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8246 34.7838C38.8246 36.117 38.286 37.3223 37.414 38.1943C36.5382 39.0701 35.3328 39.6088 33.9997 39.6088C32.6666 39.6088 31.4612 39.0701 30.5893 38.1943C30.1397 37.7475 29.7833 37.2161 29.5405 36.6307C29.2977 36.0453 29.1734 35.4176 29.1748 34.7838C29.1748 34.3187 29.5546 33.939 30.0195 33.939H37.9799C38.0908 33.939 38.2007 33.9608 38.3032 34.0032C38.4058 34.0456 38.4989 34.1079 38.5774 34.1863C38.6558 34.2648 38.7181 34.3579 38.7605 34.4605C38.8029 34.563 38.8247 34.6729 38.8246 34.7838Z",
    fill: "#F7F7F6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35_7",
    x1: 33.9997,
    y1: 3.22572,
    x2: 33.9997,
    y2: 70.0004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E50BE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F5BFB",
    stopOpacity: 0.65
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupvendo);
export default __webpack_public_path__ + "static/media/groupvendo.2ebe36efddcc380fcb19de78733613e1.svg";
export { ForwardRef as ReactComponent };